export class UpdateSession {
  static readonly type = '[Reservation] Update Session';
  constructor(public closed: boolean) {}
}
